import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_LEAD_CAPTURE_DETAIL = 'GET_LEAD_CAPTURE_DETAIL';
export const GET_LEAD_CAPTURE_DETAIL_SUCCESS =
  'GET_LEAD_CAPTURE_DETAIL_SUCCESS';
export const GET_LEAD_CAPTURE_DETAIL_FAILURE =
  'GET_LEAD_CAPTURE_DETAIL_FAILURE';

// Action Creators
export const getLeadCaptureDetail = () => ({
  type: GET_LEAD_CAPTURE_DETAIL,
});

export const getLeadCaptureDetailSuccess = (data) => ({
  type: GET_LEAD_CAPTURE_DETAIL_SUCCESS,
  payload: data,
});

export const getLeadCaptureDetailFailure = (error) => ({
  type: GET_LEAD_CAPTURE_DETAIL_FAILURE,
  payload: error,
});

// Thunk Function
export const getLeadCaptureDetailCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(getLeadCaptureDetail());
    try {
      const response = await getMethodWithToken(url.leadCapture + data + '/');
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getLeadCaptureDetailSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(getLeadCaptureDetailFailure(response?.data));
      }
    } catch (error) {
      dispatch(getLeadCaptureDetailFailure(error?.message));
    }
  };
};
